<template>
    <zen-message-modal :isOpen="isOpen" title="Delete team?">
        Deleting this team will remove all member associations. This action
        cannot be undone.
        <template v-slot:buttons>
            <zen-button
                variant="secondary"
                size="medium"
                @click="$emit('close')"
            >
                Cancel
            </zen-button>
            <zen-button
                variant="primary-danger"
                size="medium"
                :processing="processing"
                @click="$emit('confirm')"
            >
                Delete
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'DeleteTeamModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm'],
}
</script>
